module.exports = __webpack_public_path__ + "img/16.86ecf4f6.svg";